// Drive-Ordner „Postausgang – Briefe ohne Objekt“ (Wurzel der geteilten Ablage) für E-POST-Briefe ohne Objekt.
// Die Drive-ID steht in app_settings 'postausgang_ordner' ({ id }); der Aktenschrank zeigt den Ordner als eigenen
// Eintrag in der Objektauswahl (Pseudo-Objekt POSTAUSGANG_OBJEKT_ID – keine echte objekte-Zeile).
import { supabase } from '../supabase/client';

export const POSTAUSGANG_ORDNER = 'Postausgang – Briefe ohne Objekt';
export const POSTAUSGANG_OBJEKT_ID = 'postausgang';
const KEY = 'postausgang_ordner';

/** Gespeicherte Drive-ID oder null (Ordner noch nie gebraucht). */
export async function ladePostausgangOrdnerId(): Promise<string | null> {
  const { data } = await supabase.from('app_settings').select('value').eq('key', KEY).maybeSingle();
  return ((data?.value as { id?: string } | null)?.id) ?? null;
}

let sicher: Promise<string> | null = null;
/** Ordner sicherstellen (anlegen, falls nötig) und die ID merken. */
export function sicherePostausgangOrdner(): Promise<string> {
  sicher ??= (async () => {
    const vorhanden = await ladePostausgangOrdnerId();
    if (vorhanden) return vorhanden;
    const { data, error } = await supabase.functions.invoke('gdrive', { body: { action: 'ensure-folder', name: POSTAUSGANG_ORDNER } });
    if (error || !data?.id) throw new Error('Ordner „Postausgang“ nicht anlegbar');
    await supabase.from('app_settings').upsert({ key: KEY, value: { id: data.id }, updated_at: new Date().toISOString() }, { onConflict: 'key' });
    return data.id as string;
  })().catch((e) => { sicher = null; throw e; });
  return sicher;
}

/** Link in den Aktenschrank auf eine Datei in diesem Ordner. */
export const postausgangDateiPfad = (dateiId: string) =>
  `/admin/dokumente?objekt=${POSTAUSGANG_OBJEKT_ID}&datei=${encodeURIComponent(dateiId)}`;
